import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import CourseBanner from "../components/CourseBanner";
import OurServices from "../components/OurServices";
import HomeProduct from "../components/HomeProduct";

const Service = () => {
  const { pathname } = useLocation();
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const { hash } = location;
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);
  const office = [
    {
      id: 1,
      title: "Corporate Offices",
      img:"./images/office/office/Carporate-office.jpg"
    },
    {
      id: 2,
      title: "Start-Up Workspaces",
      img:"./images/office/office/Startup-workspace.jpg"
    },
    {
      id: 3,
      title: "Meeting Rooms",
      img:"./images/office/office/Meeting-room.jpg"
    },
    {
      id: 4,
      title: "Reception Areas",
      img:"./images/office/office/Reception-Desk.jpg"
    },
    {
      id: 5,
      title: "Breakout Zones",
      img:"./images/office/office/Breakout-Zones.jpg"
    },
    {
      id: 6,
      title: "Fun Area",
      img:"./images/office/office/Fun-Area.jpg"
    }
   

  ]
  const chair = [
    {
      id: 1,
      title: "Office Chairs",
      img:"./images/office/office/office-chairs.jpg"
    },
    {
      id: 2,
      title: "Office Tables",
      img:"./images/office/office/office-tables.jpg"
    },
    {
      id: 3,
      title: "Conference Tables",
      img:"./images/office/office/Conference-table.jpg"
    },
    {
      id: 4,
      title: "Discussion Table",
      img:"./images/office/office/Discussion-Table.jpg"
    },
    {
      id: 5,
      title: "Desking Series",
      img:"./images/office/office/Desking-Series.jpg"
    },
    {
      id: 6,
      title: "Reception Desk",
      img:"./images/office/office/HomeReception-Desk.jpg"
    }
   

  ]
  const storage = [
    {
      id: 1,
      title: "Filing Cabinets",
      img:"./images/office/office/Cabinet.jpg"
    },
    {
      id: 2,
      title: "Cabinets",
      img:"./images/office/office/Filing-Cabinets.jpg"
    },
    {
      id: 3,
      title: "Steel Almir",
      img:"./images/office/office/Steel-Almirah.jpg"
    },
    {
      id: 4,
      title: "Cabinet Design",
      img:"./images/office/office/filing-cabine.jpg"
    },
   

  ]
  const restaurents = [
    {
      id: 1,
      title: "Cafe Chairs",
      img:"./images/office/Cafe-Chairs-img.jpg"
    },
    {
      id: 2,
      title: "Cafe Stools",
      img:"./images/office/Cafe-Stools-img.jpg"
    },
    {
      id: 3,
      title: "Cafe Tables",
      img:"./images/office/Cafe-Tables.jpg"
    },
    
   

  ]
  const bannerData = {
    image: "./images/office/office/Office-banner.jpg",
    heading: "Inspiring Workspaces That Work for You",
    para: "Innovative office interiors designed to boost productivity and employee well-being.",
  };
  return (
    <div className="page-content">
      <Helmet>
        <title>Services</title>
        <meta
          name="description"
          content="
        and innovation."
        />
        <link rel="canonical" href="https://steamvarsity.com/about-us" />
      </Helmet>
      <CourseBanner {...bannerData} />
      <section className="bg-dark service-wrapper" id="">
        <div className="container py-5">
          <div className="row">
            <div className="col-md-12">
              <div className="wrapper">
                <div className="icon-box me-4">
                  <img src="./images/office/stand.png" alt="" />
                </div>
                <div className="content">
                
                  <p>
                  A well-designed office isn’t just about aesthetics—it’s about creating a functional and motivating environment. At Integrated Interior, we specialize in designing workspaces that inspire success.
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="col-md-4">
              <div className="wrapper">
                <div className="icon-box me-4">
                  <img src="./images/office/interior-design.png" alt="" />
                </div>
                <div className="content">
                  <h3 className="h5">Stand</h3>
                  <p>
                    Stand for your rights and your vision. We are here to help
                    you.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="wrapper">
                <div className="icon-box me-4">
                  <img src="./images/office/best-seller.png" alt="" />
                </div>
                <div className="content">
                  <h3 className="h5">Stand</h3>
                  <p>
                    Stand for your rights and your vision. We are here to help
                    you.
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      <section id="service2">
        <div className="container py-5">
          <div className="row">
            <div className="col-md-6">
              <div className="wrapper">
                <h2> Our Service for Office</h2>

                <p>
                  Smart Interior System is a one of the best office furniture
                  manufacturing company in Noida. We are manufacturing top 1000+
                  office furniture collections.
                </p>
                <ul>
                  <li><b>Corporate Offices :</b> Sophisticated designs for a professional ambiance.</li>
                  <li><b>Start-Up Workspaces :</b> Dynamic, flexible designs to fuel creativity.</li>
                  <li><b>Meeting Rooms :</b> Functional, stylish spaces for collaboration.</li>
                  <li><b>Reception Areas :</b> First impressions matter—make them count.</li>
                  <li><b>Breakout Zones :</b> Relaxed spaces for employees to recharge.</li>
                </ul>
              </div>
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-4">
              <div className="img-wrapper ">
                <img
                  className="rounded"
                  src="/images/office/office/Banner2.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="product-wrapper py-5 bg2">
        <div className="container">
        <div className="heading text-center pb-4">
      <h2>Office Interior</h2>
      <p> A well-designed office blends aesthetics with functionality. At Integrated Interior, we craft workspaces that inspire success.</p>
      </div>
          <div className="row">
            {office.map((item)=>{
              return(<div className="col-lg-4 col-md-6 mb-4" key={item.id}>
              <div className="wrapper position-relative">
                <div className="img-box ">
                  <img src={item.img} alt="" />
                </div>
                <div className="text">
                  <h3 className="h5"> {item.title}</h3>
                </div>
              </div>
            </div>)
            })}
            
          </div>
        </div>
      </section>

      <section className="product-wrapper py-5 bg2">
        <div className="container">
        <div className="heading text-center pb-4">
      <h2>Office Furniture</h2>
      <p> Modern and ergonomic office furniture designed to elevate your workspace with style and functionality.</p>
      </div>
          <div className="row">
            {chair.map((item)=>{
              return(<div className="col-lg-4 col-md-6 mb-4" key={item.id}>
              <div className="wrapper position-relative">
                <div className="img-box ">
                  <img src={item.img} alt="" />
                </div>
                <div className="text">
                  <h3 className="h5"> {item.title}</h3>
                </div>
              </div>
            </div>)
            })}
            
          </div>
        </div>
      </section>
      <section className="product-wrapper py-5 ">
        <div className="container">
        <div className="heading text-center pb-4">
      <h2>BEST QUALITY STORAGE</h2>
      <p> Premium storage solutions designed for durability, functionality, and style.</p>
      </div>
          <div className="row">
            {storage.map((item)=>{
              return(<div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={item.id}>
              <div className="wrapper position-relative">
                <div className="img-box ">
                  <img src={item.img} alt="" />
                </div>
                <div className="text">
                  <h3 className="h5"> {item.title}</h3>
                </div>
              </div>
            </div>)
            })}
            
          </div>
        </div>
      </section>
      {/* <section className="product-wrapper py-5 ">
        <div className="container">
        <div className="heading text-center pb-4">
      <h2>CAFE & RESTAURANTS</h2>
      <p> Discover Spectica's Exclusive Collection: Where Quality Meets Style.
      Experience the Perfect Blend of Durability and Design with Our Eyewear.</p>
      </div>
          <div className="row">
            {restaurents.map((item)=>{
              return(<div className="col-lg-4 col-md-6 mb-4" key={item.id}>
              <div className="wrapper position-relative">
                <div className="img-box ">
                  <img src={item.img} alt="" />
                </div>
                <div className="text">
                  <h3 className="h5"> {item.title}</h3>
                </div>
              </div>
            </div>)
            })}
            
          </div>
        </div>
      </section> */}

      <section className="bg2 py-5">
        <div className="container">
        <div className=" contact-card">
            <div className="wrapper">
            <div className="row">
                <div className="col-md-6">
                    
                        <div className="text-wrapper">
                            <h2 className="display-4 fw-bold mb-4">Connect with us</h2>

                            <p className="h4 mb-5">Good things happen when we connect.</p>
                            <a className="btn btn-black rounded-3" href="../contact-us/">Contact Us</a>

                        </div>
                   
                </div>
                <div className="col-md-6">
                    <div className="img-wrapper">
                        <img src="./images/office/customer-service.png" alt="" /> 
                    </div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </section>
    </div>
  );
};

export default Service;
